import type { QueueWarning } from '@/api/cockpit';

export function obstructiveFieldKeys(
  warningDetails?: readonly QueueWarning[],
): ReadonlySet<string> {
  const keys = new Set<string>();
  for (const warning of warningDetails ?? []) {
    if (warning.category !== 'obstructive') continue;
    for (const key of warning.fieldKeys) keys.add(key);
  }
  return keys;
}
